import { getTimeFragment } from '../util/time';
import { pad } from '../util/numbers';
import { PLAYBACK_FRAMES_PER_SECOND } from '../constants';

export default class Frame {
  _number;
  _frameMarker;

  constructor(number) {
    this._number = number;
    this._frameMarker = Frame.getFrameMarker(number);
  }

  static getFrameMarker(frameNumber) {
    const segmentTime = getTimeFragment(Frame.frameToSeconds(frameNumber), {
      floorSeconds: true,
    });
    const segmentFrameNumber = pad(Frame.subsecondFrameIndex(frameNumber), 2);
    return `${segmentTime};${segmentFrameNumber}`;
  }

  static frameToSeconds(frameNumber) {
    return frameNumber / PLAYBACK_FRAMES_PER_SECOND;
  }

  static secondsToFrame(seconds) {
    return Math.floor(seconds * PLAYBACK_FRAMES_PER_SECOND);
  }

  equals(/* Frame */ inFrame) {
    if (!(inFrame instanceof Frame)) return false;

    return (
      this.frameNumber === inFrame.frameNumber &&
      this.frameMarker === inFrame.frameMarker
    );
  }

  get frameMarker() {
    return this._frameMarker;
  }

  get frameNumber() {
    return this._number;
  }

  get seconds() {
    return Frame.frameToSeconds(this._number);
  }

  static subsecondFrameIndex(number) {
    return number % PLAYBACK_FRAMES_PER_SECOND;
  }
}
